import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import asyncRoute from '../../helpers/hoc/asyncRoute';
import routes from '../../routes';

import { PrivateRoute } from '../../utils/route-auth';
import { MODULE_PERMISSIONS } from '../../constants/permission';
import { useCurrentPlanData } from "../../hooks/useCurrentPlanData";


const List = asyncRoute(() => import('./List'));

const GlobalCreative = (props) => {
    const currentPlanData = useCurrentPlanData();
    return (<Switch>
         <Route exact path={`${props.match.path}`} render={() => <List />}/>
    </Switch>
    );
}

export default GlobalCreative;